// Generated code for Big.Process.Web.ReferenceData.SystemParameterType.
// Edit _Enum.tst to change the generated output.

export enum SystemParameterType {
    text = 0,
    integer = 1,
    date = 2,
    decimal = 3
}
(SystemParameterType as any).name = 'SystemParameterType';
